import { c as _c } from "react/compiler-runtime";
import type { CheckoutReviewLinePerSeatLimits } from '@/lib/ai/code-review-service/review-rate-limits';
import { useQuery } from '@tanstack/react-query';
import { reviewLineLimitsQueryKey } from './query-keys';
async function fetchReviewLineLimits(installationId: number): Promise<CheckoutReviewLinePerSeatLimits> {
  const params = new URLSearchParams({
    installationId: String(installationId)
  });
  const response = await fetch(`/api/billing/review-line-limits?${params.toString()}`);
  if (!response.ok) {
    throw new Error('Failed to fetch review line limits');
  }
  return response.json();
}
export function useReviewLineLimits(installationId) {
  const $ = _c(8);
  let t0;
  if ($[0] !== installationId) {
    t0 = reviewLineLimitsQueryKey(installationId);
    $[0] = installationId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== installationId) {
    t1 = () => fetchReviewLineLimits(installationId);
    $[2] = installationId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !!installationId;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}